<template>
  <div class="app-root">
    <!-- 传感器面板 -->
    <div
      ref="sensorPanel"
      class="sensor-panel"
      :class="{ collapsed: !sensorExpanded }"
    >
      <!-- 展开状态：完整头部 + 平铺数据 -->
      <div class="sensor-header" v-if="sensorExpanded" @click="toggleSensor">
        <div class="sensor-title">
          <span class="dot" :class="isDeviceOnline ? 'ok' : 'error'"></span>
          <span>环境实时</span>
        </div>
        <div class="sensor-summary">
          <span>{{ displayTemp }}°C</span>
          <span>·</span>
          <span>{{ displayHum }}%</span>
          <span>·</span>
          <span>水位 {{ waterLevelDisplay }}</span>
        </div>
        <i class="el-icon-arrow-up"></i>
      </div>
      
      <!-- 收起状态：只保留一个小按钮 -->
      <div class="sensor-toggle" v-else @click="toggleSensor">
        <i class="el-icon-s-data"></i>
        <span>环境</span>
      </div>
      
      <transition name="fade">
        <div class="sensor-body" v-if="sensorExpanded">
          <div class="metric">
            <div class="label">空气温度</div>
            <div class="value" :class="{ fault: isAbnormalField('temp') }">
              {{ isAbnormalField('temp') ? '异常' : displayTemp + '°C' }}
            </div>
          </div>
          <div class="metric">
            <div class="label">水温度</div>
            <div class="value" :class="{ fault: isAbnormalField('w_temp') }">
              {{ isAbnormalField('w_temp') ? '异常' : displayWTemp + '°C' }}
            </div>
          </div>
          <div class="metric">
            <div class="label">湿度</div>
            <div class="value" :class="{ fault: isAbnormalField('hum') }">
              {{ isAbnormalField('hum') ? '异常' : displayHum + '%' }}
            </div>
          </div>
          <div class="metric">
            <div class="label">光照</div>
            <div class="value" :class="{ fault: isAbnormalField('light') }">
              {{ isAbnormalField('light') ? '异常' : greenhouseData.light + ' lux' }}
            </div>
          </div>
          <div class="metric">
            <div class="label">水位</div>
            <div class="value" :class="{ fault: isAbnormalField('liquid') }">
              {{ isAbnormalField('liquid') ? '异常' : waterLevelDisplay }}
            </div>
          </div>
          <div class="metric">
            <div class="label">CO₂</div>
            <div class="value" :class="{ fault: isAbnormalField('co2') }">
              {{ isAbnormalField('co2') ? '异常' : greenhouseData.co2 + ' ppm' }}
            </div>
          </div>
          <div class="metric">
            <div class="label">TDS</div>
            <div class="value" :class="{ fault: isAbnormalField('TDS') }">
              {{ isAbnormalField('TDS') ? '异常' : greenhouseData.TDS + ' ppm' }}
            </div>
          </div>
          <div class="metric">
            <div class="label">电导率</div>
            <div class="value" :class="{ fault: isAbnormalField('EC') }">
              {{ isAbnormalField('EC') ? '异常' : greenhouseData.EC + ' μS/cm' }}
            </div>
          </div>
          <div class="metric">
            <div class="label">盐度</div>
            <div class="value" :class="{ fault: isAbnormalField('salinity') }">
              {{ isAbnormalField('salinity') ? '异常' : greenhouseData.salinity + ' ppt' }}
            </div>
          </div>
          <div class="metric">
            <div class="label">比重</div>
            <div class="value" :class="{ fault: isAbnormalField('SG') }">
              {{ isAbnormalField('SG') ? '异常' : greenhouseData.SG.toFixed(3) }}
            </div>
          </div>
        </div>
      </transition>
    </div>
  <!-- <div class="app-container">
    

    添加童趣装饰元素 -->
    <!-- <div class="coding-fun-elements">
      <div class="robot robot1">🤖</div>
      <div class="robot robot2">🤖</div>
      <div class="code code1">💻</div>
      <div class="code code2">💻</div>
      <div class="gear gear1">⚙️</div>
      <div class="gear gear2">⚙️</div>
      <div class="rocket rocket1">🚀</div>
      <div class="rocket rocket2">🚀</div>
      <div class="lightning lightning1">⚡</div>
      <div class="lightning lightning2">⚡</div>
    </div> 

    <iframe
      src="http://127.0.0.1:9091/scratch/index.html"
      frameborder="0"
    ></iframe>
  </div> -->
<!-- Scratch 容器 -->
<div class="scratch-container" :class="{ 'collapsed': !sensorExpanded }">
      <iframe
        src="https://www.yaqiu.online/scratch/index.html"
        frameborder="0"
      ></iframe>
      <!-- <iframe
        src="http://127.0.0.1:9091/scratch/index.html"
        frameborder="0"
      ></iframe> -->
    </div>
</div>
</template>

<script>
export default {
  data() {
    return {
      greenhouseId: '',
      greenhouseStatus: 0,
      greenhouseData: {
        hum: 0,
        temp: 0,
        w_temp: 0,
        liquid: 0,
        light: 0,
        co2: 0,
        TDS: 0,
        EC: 0,
        salinity: 0,
        SG: 0,
      },
      // 进入页面默认展开
      sensorExpanded: true,
      pollTimer: null,
      sensorPos: {
        top: null,
        left: null,
      },
      sensorDragging: false,
      dragStart: {
        x: 0,
        y: 0,
      },
      panelStart: {
        top: 0,
        left: 0,
      },
    };
  },
  computed: {
    isDeviceOnline() {
      return Number(this.greenhouseStatus) === 0;
    },
    displayTemp() {
      return this.formatTemp(this.greenhouseData.temp);
    },
    displayWTemp() {
      return this.formatTemp(this.greenhouseData.w_temp);
    },
    displayHum() {
      const v = Number(this.greenhouseData.hum);
      return isFinite(v) ? v.toFixed(0) : '-';
    },
    waterLevelDisplay() {
      const level = Number(this.greenhouseData.liquid);
      if (!isFinite(level)) return '-';
      if (level < 1) return level.toFixed(3) + '%';
      return level.toFixed(1) + '%';
    },
    sensorPanelStyle() {
      const style = {};
      if (this.sensorPos.top !== null) {
        style.top = this.sensorPos.top + 'px';
      }
      if (this.sensorPos.left !== null) {
        style.left = this.sensorPos.left + 'px';
      }
      return style;
    },
  },
  mounted() {
    // 编程页面进入动画
    this.enterAnimation();
    this.greenhouseId = localStorage.getItem('ms_greenhouseId');
    this.loadSensorInfo();
    this.pollTimer = setInterval(() => {
      this.loadSensorInfo();
    }, 10000);
    this.$nextTick(() => {
      this.initSensorPosition();
    });
  },
  beforeDestroy() {
    if (this.pollTimer) {
      clearInterval(this.pollTimer);
      this.pollTimer = null;
    }
    this.removeDragListeners();
  },
  methods: {
    enterAnimation() {
      // 为编程页面元素添加进入动画
      const elements = document.querySelectorAll('.app-container, .coding-fun-elements > *');
      elements.forEach((el, index) => {
        el.style.opacity = '0';
        el.style.transform = 'translateY(60px) scale(0.8)';
        el.style.transition = 'all .2s cubic-bezier(0.68, -0.55, 0.27, 1.55)';
        
        setTimeout(() => {
          el.style.opacity = '1';
          el.style.transform = 'translateY(0) scale(1)';
        }, index * 30);
      });
    },
    initSensorPosition() {
      try {
        const panel = this.$refs.sensorPanel;
        if (!panel) return;
        const rect = panel.getBoundingClientRect();
        const vw = window.innerWidth || document.documentElement.clientWidth;
        const defaultTop = rect.top;
        const defaultLeft = (vw - rect.width) / 2;
        this.sensorPos.top = defaultTop;
        this.sensorPos.left = defaultLeft < 8 ? 8 : defaultLeft;
      } catch (e) {
        console.warn('initSensorPosition failed', e);
      }
    },
    onSensorMouseDown(e) {
      // 只响应左键拖动
      if (e.button !== 0) return;
      const panel = this.$refs.sensorPanel;
      if (!panel) return;
      const rect = panel.getBoundingClientRect();
      this.sensorDragging = true;
      this.dragStart.x = e.clientX;
      this.dragStart.y = e.clientY;
      // 若还没有记录位置，从当前 rect 取
      this.panelStart.top = this.sensorPos.top !== null ? this.sensorPos.top : rect.top;
      this.panelStart.left = this.sensorPos.left !== null ? this.sensorPos.left : rect.left;
      window.addEventListener('mousemove', this.onSensorMouseMove);
      window.addEventListener('mouseup', this.onSensorMouseUp);
    },
    onSensorMouseMove(e) {
      if (!this.sensorDragging) return;
      const dx = e.clientX - this.dragStart.x;
      const dy = e.clientY - this.dragStart.y;
      let newTop = this.panelStart.top + dy;
      let newLeft = this.panelStart.left + dx;
      const vw = window.innerWidth || document.documentElement.clientWidth;
      const vh = window.innerHeight || document.documentElement.clientHeight;
      const panel = this.$refs.sensorPanel;
      const rect = panel ? panel.getBoundingClientRect() : { width: 0, height: 0 };
      // 简单边界限制，避免拖出视口
      const margin = 8;
      const maxTop = vh - rect.height - margin;
      const maxLeft = vw - rect.width - margin;
      if (newTop < margin) newTop = margin;
      if (newTop > maxTop) newTop = maxTop;
      if (newLeft < margin) newLeft = margin;
      if (newLeft > maxLeft) newLeft = maxLeft;
      this.sensorPos.top = newTop;
      this.sensorPos.left = newLeft;
    },
    onSensorMouseUp() {
      this.sensorDragging = false;
      this.removeDragListeners();
    },
    removeDragListeners() {
      window.removeEventListener('mousemove', this.onSensorMouseMove);
      window.removeEventListener('mouseup', this.onSensorMouseUp);
    },
    async loadSensorInfo() {
      if (!this.greenhouseId) return;
      try {
        const res = await this.$request.callApi('GET', this.$robotApi.sensorInfo, {
          greenhouseId: this.greenhouseId,
        });
        if (res && res.data) {
          if (res.data.device) {
            this.greenhouseStatus = res.data.device.greenhouseStatus;
          }
          const cv = (res.data.envData && res.data.envData[0] && res.data.envData[0].currentValue) || {};
          this.greenhouseData = {
            hum: typeof cv.hum === 'number' ? cv.hum : 0,
            temp:
              typeof cv.temp === 'number'
                ? cv.temp.toFixed(1)
                : typeof cv.tempe === 'string'
                ? Number(cv.tempe).toFixed(1)
                : (Number(cv.temp) || 0).toFixed(1),
            w_temp: typeof cv.w_temp === 'number' ? cv.w_temp.toFixed(1) : 0,
            liquid: typeof cv.liquid === 'number' ? cv.liquid : 0,
            light: Number(cv.light) || 0,
            co2: Number(cv.co2) || 0,
            TDS: Number(cv.TDS) || 0,
            EC: Number(cv.EC) || 0,
            salinity: Number(cv.salinity) || 0,
            SG: Number(cv.SG) || 0,
          };
          localStorage.setItem("gd" + this.greenhouseId, JSON.stringify(this.greenhouseData));
        }
      } catch (err) {
        console.warn('loadSensorInfo failed', err);
      }
    },
    toggleSensor() {
      this.sensorExpanded = !this.sensorExpanded;
      // 可以添加一些平滑过渡效果
      if (this.sensorExpanded) {
        this.$nextTick(() => {
          // 展开后如果需要可以滚动到顶部
        });
      }
    },
    isAbnormalField(key) {
      const value = this.greenhouseData && this.greenhouseData[key];
      if (value === undefined || value === null) return false;
      if (typeof value === 'number') return Number(value) === -50;
      if (typeof value === 'string') return value === '-50';
      return false;
    },
    formatTemp(value) {
      if (value === null || value === undefined || isNaN(Number(value))) return '-';
      try {
        return Number(value).toFixed(1);
      } catch (e) {
        return value;
      }
    },
  }
};
</script>
  <style lang="scss" scoped>
.app-root {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
}

.sensor-panel {
  flex-shrink: 0; /* 不收缩 */
  transition: height 0.3s ease;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(6px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.4);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  z-index: 10;
  
  /* 展开状态高度 */
  &:not(.collapsed) {
    height: auto; /* 或固定高度如 200px，根据内容自适应 */
  }
  
  /* 收起状态 */
  &.collapsed {
    height: 34px; /* 按钮高度 */
    background: transparent;
    border-bottom: none;
    box-shadow: none;
  }
}

.sensor-header {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  cursor: pointer;
  color: #2c3e50;
  font-weight: 600;
  height: 44px; /* 固定头部高度 */
}

.sensor-toggle {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 6px 10px;
  margin: 6px 0 6px 10px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 999px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.18);
  cursor: pointer;
  color: #2c3e50;
  font-size: 13px;
  width: fit-content;
}

.sensor-body {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 8px;
  padding: 0 12px 12px 12px;
}

.scratch-container {
  flex: 1; /* 占据剩余空间 */
  position: relative;
  transition: margin-top 0.3s ease;
  overflow: hidden;
  
  iframe {
    width: 100%;
    height: 100%;
    border: none;
    display: block;
  }
}
  .sensor-title {
    display: flex;
    align-items: center;
    gap: 6px;
  }
  .dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    display: inline-block;
    box-shadow: 0 0 0 4px rgba(0,0,0,0.04);
  }
  .dot.ok { background: #4caf50; }
  .dot.error { background: #f44336; }
  .sensor-summary {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    color: #607d8b;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
 
  .metric {
    background: rgba(255,255,255,0.85);
    border: 1px solid #e3f2fd;
    border-radius: 10px;
    padding: 8px 10px;
    box-shadow: 0 1px 2px rgba(0,0,0,0.04);
  }
  .metric .label {
    font-size: 12px;
    color: #7f8c8d;
    margin-bottom: 2px;
  }
  .metric .value {
    font-size: 16px;
    font-weight: 700;
    color: #2c3e50;
  }
  .metric .value.fault {
    color: #f44336;
  }
  .fade-enter-active, .fade-leave-active { transition: opacity .15s ease; }
  .fade-enter, .fade-leave-to { opacity: 0; }
/* 收起时调整 Scratch 容器 */
.scratch-container.collapsed {
  margin-top: 0;
}
  /* 收起状态的小按钮样式 */

  .sensor-toggle i {
    color: #409eff;
    font-size: 16px;
  }

  /* 童趣装饰元素 */
  .coding-fun-elements {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: 10;
  }

  .robot {
    position: absolute;
    font-size: 40px;
    animation: floatRobot 2s ease-in-out infinite;
  }

  .robot.robot1 {
    top: 8%;
    left: 5%;
    animation-delay: 0s;
  }

  .robot.robot2 {
    top: 15%;
    right: 8%;
    animation-delay: 1s;
  }

  .code {
    position: absolute;
    font-size: 35px;
    animation: rotateCode 1.5s ease-in-out infinite;
  }

  .code.code1 {
    top: 30%;
    left: 12%;
    animation-delay: 0.4s;
  }

  .code.code2 {
    top: 40%;
    right: 15%;
    animation-delay: 1.2s;
  }

  .gear {
    position: absolute;
    font-size: 30px;
    animation: spinGear 1.5s linear infinite;
  }

  .gear.gear1 {
    bottom: 25%;
    left: 8%;
    animation-delay: 0.2s;
  }

  .gear.gear2 {
    bottom: 35%;
    right: 12%;
    animation-delay: 1s;
  }

  .rocket {
    position: absolute;
    font-size: 32px;
    animation: flyRocket 3s ease-in-out infinite;
  }

  .rocket.rocket1 {
    top: 50%;
    left: 3%;
    animation-delay: 0.2s;
  }

  .rocket.rocket2 {
    top: 60%;
    right: 5%;
    animation-delay: 1.5s;
  }

  .lightning {
    position: absolute;
    font-size: 28px;
    animation: flashLightning 1s ease-in-out infinite;
  }

  .lightning.lightning1 {
    bottom: 15%;
    left: 20%;
    animation-delay: 1.5s;
  }

  .lightning.lightning2 {
    bottom: 20%;
    right: 25%;
    animation-delay: 1.5s;
  }

  @keyframes floatRobot {
    0%, 100% {
      transform: translateY(0) rotate(0deg);
    }
    50% {
      transform: translateY(-35px) rotate(10deg);
    }
  }

  @keyframes rotateCode {
    0%, 100% {
      transform: rotate(0deg) scale(1);
    }
    50% {
      transform: rotate(180deg) scale(1.1);
    }
  }

  @keyframes spinGear {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  @keyframes flyRocket {
    0%, 100% {
      transform: translateY(0) translateX(0) rotate(0deg);
    }
    25% {
      transform: translateY(-40px) translateX(20px) rotate(15deg);
    }
    50% {
      transform: translateY(-20px) translateX(-15px) rotate(-10deg);
    }
    75% {
      transform: translateY(-50px) translateX(5px) rotate(5deg);
    }
  }

  @keyframes flashLightning {
    0%, 100% {
      opacity: 0.3;
      transform: scale(1);
    }
    50% {
      opacity: 1;
      transform: scale(1.4);
    }
  }

  /** 开启tag标签  */
  .hasTagsView {
    .app-container {
      /* 84px = navbar + tags-view = 50px + 34px */
      height: calc(100vh - 84px);
      top: 84px;
    }
    .sensor-panel {
      top: 84px;
    }
  }

  iframe {
    width: 100%;
    height: 100%;
    border: none;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
  }
  </style>
  